import React from 'react'
import styles from '../AdminPanelPage.module.scss'

// Форма создания ТЭЦ (CHPP) — аналог CreateTopBaseForm
const CreateChppForm = ({ modalPayload = {}, setModalPayload = () => {}, closeModal = () => {}, createChpp, loadChpps = async () => {}, notifySuccess = () => {}, notifyError = () => {} }) => {
  return (
    <>
      <label>Название ТЭЦ</label>
      <input placeholder="Название ТЭЦ" value={modalPayload.name || ''} onChange={(e) => setModalPayload(p => ({ ...p, name: e.target.value }))} />
      <label>Телефон</label>
      <input placeholder="Телефон" value={modalPayload.phone || ''} onChange={(e) => setModalPayload(p => ({ ...p, phone: e.target.value }))} />
      <label>Геолокация (широта,долгота)</label>
      <input placeholder="42.8746,74.5698" value={modalPayload.geo || ''} onChange={(e) => setModalPayload(p => ({ ...p, geo: e.target.value }))} />
      <div style={{ display: 'flex', gap: 8 }}>
        <button onClick={() => { closeModal() }} className={styles.btn_pin_close}>Отмена</button>
        <button onClick={async () => {
          try { await createChpp(modalPayload); await loadChpps(); closeModal(); notifySuccess('ТЭЦ создана') } catch (err) { console.error(err); notifyError(err, 'Не удалось создать ТЭЦ') }
        }} className={styles.btn_pin}>Создать</button>
      </div>
    </>
  )
}

export default CreateChppForm
